<template>
  <div class="circles">
    <span class="circle circle-1" :style="{ 'borderColor': color }"></span>
    <span class="circle circle-2" :style="{ 'borderColor': color }"></span>
    <span class="circle circle-3" :style="{ 'borderColor': color }"></span>
    <span class="circle circle-4" :style="{ 'borderColor': color }"></span>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff",
      required: false,
    },
  },
};
</script>

<style lang="scss">
.circles {
  position: absolute;
  width: 100%;
  padding-top: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .circle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: 50%;
    animation: rotate infinite linear;

    &.circle-1 {
      transform-origin: 49% 51%;
      animation-duration: 8s;
    }

    &.circle-2 {
      transform-origin: 52% 50%;
      animation-duration: 9s;
      animation-direction: backwards;
    }

    &.circle-3 {
      transform-origin: 50% 48%;
      animation-duration: 7.5s;
      animation-direction: backwards;
    }

    &.circle-4 {
      transform-origin: 48% 49%;
      animation-duration: 9.5s;
    }
  }
}

@keyframes rotate {
  from {
    transform: rotateZ(0deg);
  }

  to {
    transform: rotateZ(360deg);
  }
}
</style>